import { useEffect, useRef } from "react";
import { clearStaleWait, trackReady } from "../../slices/recordingSlice";
import { useAppDispatch, useAppSelector } from "../../storeHooks";
const TRACK_WAIT_TIMEOUT_MS = 10000;
export const usePersistentRecording = (label, isTrackLive, onResume, onTimeout) => {
    const dispatch = useAppDispatch();
    //const isWaiting = useAppSelector(selectIsWaiting);
    const isWaiting = useAppSelector((store) => store.recording.waitingSince);
    const pendingResume = useAppSelector((store) => store.recording.pendingResume);
    const timeoutRef = useRef(null);
    const resumedRef = useRef(false);
    // Resume as soon as track is live and store says we're pending
    useEffect(() => {
        if (!pendingResume || !isTrackLive || resumedRef.current)
            return;
        resumedRef.current = true;
        dispatch(trackReady(label));
        onResume();
    }, [pendingResume, isTrackLive]);
    // Arm the timeout whenever we enter waiting_for_tracks
    useEffect(() => {
        if (!isWaiting)
            return;
        resumedRef.current = false;
        timeoutRef.current = setTimeout(() => {
            console.warn(`[Recording] Track "${label}" timed out — clearing pending state`);
            dispatch(clearStaleWait());
            onTimeout();
        }, TRACK_WAIT_TIMEOUT_MS);
        return () => {
            if (timeoutRef.current)
                clearTimeout(timeoutRef.current);
        };
    }, [isWaiting]);
    // Cancel local timeout on unmount; store state intentionally survives
    useEffect(() => {
        return () => {
            if (timeoutRef.current)
                clearTimeout(timeoutRef.current);
        };
    }, []);
    return { isWaiting };
};
